import { defineStore } from "pinia"

// The access token the google_token function returns (see README in common/google).
export interface GoogleToken {
  token: string
  expires_at: string
  /** The scopes this token was granted, space-separated. */
  scope?: string
}

// shared state for google APIs & libraries
export const useGoogleStore = defineStore("google", {
  state: () => ({
    // manual authorization needs to be run for the current user
    authorizationNeeded: false,
    // google identity services library is loaded
    librariesLoaded: false,
    // libraries are fully loaded and token check has completed
    ready: false,
    // short lived access token (see README in common/google)
    token: null as GoogleToken | null,
  }),

  getters: {
    // google is fully loaded and we have a live token
    googleAvailable: (state) => state.ready && !!state.token?.token,
  },

  actions: {
    setAuthorizationNeeded(needed: boolean) {
      this.authorizationNeeded = needed
    },
    libraryLoadingComplete() {
      this.librariesLoaded = true
    },
    resetGoogle() {
      this.authorizationNeeded = true
      this.token = null
    },
    setReady(ready: boolean) {
      this.ready = ready
    },
    setToken(token: GoogleToken | null) {
      this.token = token
    },
  },
})
